import { useRef } from 'react';

import { v4 as uuidv4 } from 'uuid';

/**
 * Generates stable unique keys for a list of items.
 * The keys remain consistent across re-renders as long as the length of the items array does not change.
 *
 * @param items - The array of items for which to generate stable keys.
 * @returns An array of unique string keys corresponding to each item.
 */
export function useStableKeys<T>(items: T[]): string[] {
  const keysRef = useRef<string[]>([]);
  if (keysRef.current.length !== items.length) {
    keysRef.current = items.map(() => uuidv4());
  }
  return keysRef.current;
}
